import React, { Component } from "react";
import { connect } from "react-redux";

import FormsUserUpdate from "../../component/forms/user/profile";

class ProfilePage extends Component {
  render() {
    // The two child forms connect to their own actions, so nothing is
    // prop-drilled through here any more.
    return <FormsUserUpdate user={this.props.user} />;
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(ProfilePage);
